import SignUp from './SignUp'
import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import { Form } from 'antd'

const mapStateToProps = state => ({
  global: state.global
})

const mapDispatchToProps = {
  changeRoute: push
}

export default Form.create()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SignUp)
)
